import type { TRGBAColorWith1AtTheEnd } from 'settings/colors'
import { colors } from 'settings/colors'

const { idealBadge, moderateDeficitBadge, extremeDeficitBadge } = colors

export const getAlternariaColorForValueAndThreshold = (
  dsv7Days: number,
  threshold: number,
): TRGBAColorWith1AtTheEnd => {
  const riskPercentage = dsv7Days / threshold

  if (riskPercentage < 0.2) return idealBadge

  if (riskPercentage < 0.8) return moderateDeficitBadge

  return extremeDeficitBadge
}
